import { Spin, Form } from 'antd';
import { useState } from 'react';
import { ForumTopic } from '../../../../models/forumTopic';
import { createForumTopic } from '../../../../service/forumTopic';
import { createErrorNotification, createSuccessNotification } from '../../../../service/notification';
import Button from '../../../../components/Button/Button';
import Input from '../../../../components/Input/Input';
import FormItem from '../../../../components/FormItem/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import styles from './CreateTopic.module.scss';

type Props = Pick< ForumTopic, 'clubId' | 'userId' | 'forumId'> 
& {
  refetchData: () => void
};

export const CreateTopic = ({ clubId, forumId, userId, refetchData }: Props) => {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (payload) => {
    if(loading) return;

    setLoading(true);

    const {error, success} = await createForumTopic({
      title: payload.title,
      description: payload.description 
    }, clubId, forumId, userId);

    setLoading(false);
      
    if(error) return createErrorNotification(error);
    createSuccessNotification('Tópico de discussão do fórum criado!');

    refetchData();
  }


  return(
    <div>
      <Form 
        layout="vertical" 
        form={form}
        onFinish={onFinish}
        id="formLogin" 
        className={styles.form}
      >
        <FormItem
          label="Título de Novo Tópico do Fórum"
          name="title"
          rules={[
            {
              required: true,
              message: 'Por favor, digite um título.',
            },
            {
              max: 255,
              message: 'Título deve ter entre 1 e 255 caracteres.',
            }
          ]}
          required
        >
          <Input style={styles.input} placeholder="Título do novo tópico de discussão do fórum"/>
        </FormItem>
        <FormItem
          label="Descrição"
          name="description"
          rules={[
            {
              required: true,
              message: 'Por favor, faça uma descrição do tópico do fórum',
            }
          ]}
          required
        >
          <TextArea className={styles.input} placeholder="Descrição do tópico de discussão do fórum..." />
        </FormItem>
        <Spin spinning={loading}>
          <Button submit style={styles.button}>Criar Novo Tópico de Discussão</Button>
        </Spin>
      </Form>
    </div>    
  );
}
